export class AuditProgramAIRItemDocumentDTO {
  document_Type: string;
  documentId: string;
  siteId: string;
  auditProgramId: string;
  airItemId: string;
  statusId: string;
  filePath: string;
  fileName: string;
  fileSize: string;
  fileType: string;
  isUploadedByAuditees: string = '0';
  actionType: string;
  airDescription: string;
  userType: string;
  auditeeAction: string;
  auditorAction: string;
  tabType: string;
  uploadedByName: string;
  UploadedDate: string;
  auditorActionId: string;
  auditeeActionId: string;
  auditorRemarks: string;
  auditeeRemarks: string;
  auditorLastComment: string;
  auditeeLastComment: string;
  auditorLastCommentTime: string;
  auditeeLastCommentTime: string;
  isMcReleased: string;
  departmentId: string;
  isAttachmentRequired: number;
}
